import React, { useEffect, useState } from "react";
import { IoDocumentText } from "react-icons/io5";
import { MdEditDocument } from "react-icons/md";
export function ParentSection({ parent, kids, activeMenu, onSelect, sidebarOpen }) {

    const [open, setOpen] = useState(false);

    const hasActiveChild = kids.some(
        (k) => k.target?.toLowerCase() === activeMenu
    );

    useEffect(() => {
        if (hasActiveChild) setOpen(true);
    }, [hasActiveChild]);

    return (
        <li className="parent-menu">

            <div
                className={`parent-title ${hasActiveChild ? "parent-has-active" : ""}`}
                role="button"
                tabIndex={0}
                onClick={() => setOpen(!open)}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        setOpen(!open);
                    }
                }}
            >
                <div className="parent-icon">
                    {sidebarOpen && (
                        <>
                            <IoDocumentText size={16} className="me-2" />
                            <span>{parent.service_name}</span>
                        </>
                    )}
                </div>

                {sidebarOpen && (
                    <span className="parent-arrow">{open ? "▾" : "▸"}</span>
                )}
            </div>

            {open && (
                <div className="children-wrapper">
                    {kids.map((child) => (
                        <div
                            key={child.service_id}
                            role="button"
                            tabIndex={0}
                            className={`child-item ${activeMenu === child.target?.toLowerCase()
                                ? "active"
                                : ""
                                }`}
                            onClick={() => onSelect(child)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    onSelect(child);
                                }
                            }}
                        >
                            <IoDocumentText size={16} className="me-2" />
                            <span>{child.service_name}</span>
                        </div>
                    ))}
                </div>
            )}
        </li>
    );
}

export function MenuItem({ item, kids, activeMenu, onSelect, sidebarOpen, defaultIcon }) {

    const ItemIcon = defaultIcon || MdEditDocument;

    if (kids && kids.length > 0) {
        return (
            <ParentSection
                parent={item}
                kids={kids}
                activeMenu={activeMenu}
                onSelect={onSelect}
                sidebarOpen={sidebarOpen}
            />
        );
    }

    return (
        <li
            className={`single-menu ${activeMenu === item?.target?.toLowerCase()
                ? "active"
                : ""
                }`}
            role="menuitem"
            tabIndex={0}
            onClick={() => onSelect(item)}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    onSelect(item);
                }
            }}
        >
            <ItemIcon size={16} className="me-2" />
            {sidebarOpen && <span>{item.service_name}</span>}
        </li>
    );
}

export const showValue = (value) => (value ? value : "-");